import { lazy } from 'react';
export const LineTrend = lazy(() =>
  import('./LineTrend').then((m) => ({ default: m.LineTrend })),
);
export const BarCompare = lazy(() =>
  import('./BarCompare').then((m) => ({ default: m.BarCompare })),
);
export const DonutShare = lazy(() =>
  import('./DonutShare').then((m) => ({ default: m.DonutShare })),
);
export const ParetoChart = lazy(() =>
  import('./ParetoChart').then((m) => ({ default: m.ParetoChart })),
);
export type { BarDatum } from './BarCompare';
export type { ShareSlice } from './DonutShare';
export type { TrendPoint } from './LineTrend';
export type { ParetoDatum } from './ParetoChart';
